import React, { useEffect, useState } from 'react'

const tikTokIcon = (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{ width: '24px', height: '24px', fill: '#ffffff' }}>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.12v12.11a2.9 2.9 0 1 1-2-2.75V8.19a6.03 6.03 0 1 0 5.12 5.92V8.02a7.9 7.9 0 0 0 4.77 1.6V6.69Z" />
    </svg>
);

const Whatsapp = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setShowScrollTop(window.scrollY > 160);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    right: '14px',
                    bottom: '14px',
                    zIndex: 1000,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                }}
            >
                <a
                    href="https://www.tiktok.com/@arkabcollections5"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="TikTok"
                    aria-label="TikTok"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '42px',
                        height: '42px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        background: '#111111',
                        boxShadow: '0 2px 7px rgba(0,0,0,0.22)',
                    }}
                >
                    {tikTokIcon}
                </a>

                <a
                    href="https://www.instagram.com/arkabcollections512"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '42px',
                        height: '42px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        boxShadow: '0 2px 7px rgba(0,0,0,0.22)',
                    }}
                >
                    <img src="/arkab/icons8-instagram-logo-96.png" alt="Instagram" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </a>

                <a
                    href="https://wa.link/pfegsv"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="WhatsApp"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '42px',
                        height: '42px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        boxShadow: '0 2px 7px rgba(0,0,0,0.22)',
                    }}
                >
                    <img src="/arkab/icons8-whatsapp-80.png" alt="WhatsApp" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </a>
            </div>

            {showScrollTop ? (
                <button
                    type="button"
                    onClick={handleScrollTop}
                    title="Back to top"
                    aria-label="Back to top"
                    style={{
                        position: 'fixed',
                        left: '14px',
                        bottom: '14px',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '42px',
                        height: '42px',
                        borderRadius: '50%',
                        border: 'none',
                        background: '#1f1f23',
                        color: '#ffffff',
                        fontSize: '20px',
                        fontWeight: 700,
                        boxShadow: '0 2px 7px rgba(0,0,0,0.22)',
                        cursor: 'pointer',
                    }}
                >
                    ↑
                </button>
            ) : null}
        </>
    );
};

export default Whatsapp;
